import fetch from '@/utils/fetch';
//查询套餐列表
export function getSchooloverComboList(listQuery) {
    let params = new URLSearchParams();
    params.append('pageNo', listQuery.pageNo);
    params.append('pageSize', listQuery.pageSize);
    params.append('searchTitle', listQuery.searchTitle);
    params.append('state', listQuery.state);
    params.append('useType', listQuery.useType);
    return fetch({
        url: 'structure/schooloverCombo/getSchooloverComboList',
        method: 'get',
        params
    });
  }

//删除套餐
export function delSchooloverCombo(equipmentId) {
    let params = new URLSearchParams();
    params.append('equipmentId', equipmentId);
    return fetch({
        url: 'structure/schooloverCombo/delSchooloverCombo',
        method: 'GET',
        params
    });
}

//根据设备号查询套餐详情
export function getSchooloverCombo(equipmentId) {
    let params = new URLSearchParams();
    params.append('equipmentId', equipmentId);
    return fetch({
        url: 'structure/schooloverCombo/getSchooloverCombo',
        method: 'GET',
        params
    });
}
//根据设备号查询套餐静态卡
export function getSchooloverComboCardStaticList(equipmentId) {
    let params = new URLSearchParams();
    params.append('equipmentId', equipmentId);
    return fetch({
        url: 'structure/schooloverCombo/getSchooloverComboCardStaticList',
        method: 'GET',
        params
    });
}

//修改套餐
export function updateSchooloverCombo(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/schooloverCombo/updateSchooloverCombo',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }
//套餐绑定
export function bindSchooloverCombo(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/schooloverCombo/bindSchooloverCombo',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }
//放学套餐发货
export function consignorSchooloverCombo(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/schooloverCombo/consignorSchooloverCombo',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }
//新增套餐
export function addSchooloverCombo(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/schooloverCombo/addSchooloverCombo',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }
//生成套餐静态卡
export function addSchooloverComboCardStaticList(args) {
    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: 'structure/schooloverCombo/addSchooloverComboCardStaticList',
        method: 'POST',
        data: JSON.stringify(args)
    });
  }


// WEBPACK FOOTER //
// ./src/api/schoolRoadTeamPackage.js